import React from "react";
import { Switch, Route } from "react-router-dom";
import CreatePage from "./components/pages/createPage/CreatePage";
import ListPage from "./components/pages/listPage/ListPage";
import ClusterPage from "./components/pages/clustersPage/ClustersPage";
import CausePage from "./components/pages/causePage/CausePage";

export const Path = {
  list: "/",
  create: "/create",
  edit: "/edit",
  clusters: "/clusters",
  cause: "/cause"
};

const Routes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path={Path.list} component={ListPage} />
      <Route exact path={Path.create + `/:id?`} component={CreatePage} />
      <Route exact path={Path.clusters} component={ClusterPage} />
      <Route exact path={Path.cause} component={CausePage} />
    </Switch>
  );
};

export default Routes;